<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="page_8">About the Authors</a></h3><a id="page_8">
<p class="textcenter">Don and Debra Macleod are husband-and-wife authors whose sex and relationship books have helped thousands of couples learn to love—and lust!—for a lifetime.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// about.vue?3c848992